<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="search"
        :placeholder="$t('action.buttons.search')"
        flat
        hide-details
        prepend-icon="search"
        solo
      />
      <meta-button type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :items="formatedList"
        :headers="headers"
        :expand="expand"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        :search="search"
        disable-initial-sort
        item-key="_id"
      >
        <!--        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"-->
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="primary"
              class="mr-1"
              @click="ifClone(props.item._id)"
            >
              file_copy
            </v-icon>
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon color="error" @click="ifDelete(props.item._id)">
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.type }}</td>
          <td
            class="text-xs-center cursor"
            @click="props.expanded = !props.expanded"
          >
            <i class="icon material-icons">visibility</i>
          </td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
        <template slot="expand" slot-scope="props">
          <v-container class="text-xs-left" mx-0>
            <v-layout row wrap>
              <v-flex
                v-for="(item, index) in props.item.permissions"
                :key="index"
              >
                <v-icon small> done_all </v-icon>
                {{ item }}
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-clone
      :dialog.sync="dialogClone"
      :loading="loading"
      @clone="setClone(idClone)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogClone from '@/components/widgets/dialog/DialogClone'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'RoleList',
  components: { DialogDelete, DialogClone, DialogUpdatedRecord },
  data() {
    return {
      search: '',
      expand: false,
      idDelete: '',
      idClone: '',
      dialogDelete: false,
      dialogClone: false,
      dialogUpdated: false,
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.roles.loading,
      selected: (state) => state.roles.selected,
      pagination: (state) => state.roles.pagination,
    }),
    ...mapGetters({
      formatedList: 'roles/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$t('fields.global.type'),
          value: 'type',
        },
        {
          text: this.$t('fields.global.permissions'),
          align: 'center',
          value: 'permissions',
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('roles/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    // search(val) {
    //   if (this.localPagination.page !== 1) this.localPagination.page = 1
    //   else this.debounceFetch()
    // },
    // 'localPagination.page': {
    //   handler: function(val, oldVal) {
    //     this.fetchList({ match: this.search })
    //   }
    // }
  },

  methods: {
    ...mapActions({
      fetchOne: 'roles/fetchOne',
      setCreate: 'roles/create',
      setDelete: 'roles/delete',
      reset: 'roles/reset',
      fetchList: 'roles/fetchList',
    }),
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then((_) => this.$emit('form'))
    },
    setNew() {
      this.$emit('clear')
      this.$emit('form')
    },
    openUpdated(id) {
      this.$emit('clear')
      this.fetchOne(id).then((_) => (this.dialogUpdated = true))
    },
    ifClone(id) {
      this.idClone = id
      this.dialogClone = true
    },
    setClone(id) {
      this.fetchOne(id).then((role) => {
        let payload = parseObject(role)
        delete payload._id
        payload.name.forEach((item) => (item.text += ' (copy)'))
        this.setCreate(payload).then((_) => (this.dialogClone = false))
      })
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    debounceFetch: debounce(function () {
      this.fetchList({
        match: this.search,
      })
    }, 1000),
  },
}
</script>
